import ArrowForward from '@hc-frontend/core-icons/kit/arrow-forward';
import { Button, Link } from '@hc-frontend/core-ui';

import { ZIP_CODE } from './constants';
import { useSubsidyCalculator } from './provider';

export function SuccessView() {
  const { subsidy, answers, reset, trackingParameters, sessionParameters } =
    useSubsidyCalculator();

  const subsidyValue = subsidy?.subsidyValue ?? 0;
  const subsidyValueFormatted = subsidyValue.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });

  const annualSubsidyValue = subsidyValue * 12;
  const annualSubsidyValueFormatted = annualSubsidyValue.toLocaleString(
    'en-US',
    {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    },
  );

  const isSubsidyEligible = subsidyValue > 0;
  const zip = answers[ZIP_CODE];

  const redirectParams = new URLSearchParams(trackingParameters);

  if (zip !== undefined) {
    redirectParams.set('zip', zip);
  }

  if (sessionParameters.userId !== undefined) {
    redirectParams.set('uid', sessionParameters.userId);
  }
  if (sessionParameters.sessionId !== undefined) {
    redirectParams.set('sid', sessionParameters.sessionId);
  }

  return (
    <div className="bg-background-50 rounded-2xl px-12-24 py-40-40 flex flex-col items-center justify-center">
      <p className="hc-typography--heading-three text-center animate-in fade-in slide-in-from-bottom-8-8 duration-1000 fill-mode-both">
        Your Estimated Savings
      </p>
      <p className="hc-typography--paragraph-md text-center mt-4-4 animate-in fade-in slide-in-from-bottom-8-8 duration-1000 delay-150 fill-mode-both">
        {isSubsidyEligible
          ? 'Great news! You may be eligible for a tax credit to help lower the cost of your monthly health insurance premium.'
          : 'Based on the information you provided, you may not qualify for a premium tax credit at this time. However, you can still explore affordable health insurance options.'}
      </p>

      <div className="bg-gray-0 rounded-xl border border-gray-50 py-32-32 px-24-24 mt-32-32 text-center w-full animate-in fade-in slide-in-from-bottom-8-8 duration-1000 delay-300 fill-mode-both">
        <p className="hc-typography--paragraph-md text-center">
          Monthly Premium Tax Credit
        </p>
        <p className="hc-typography--title-case text-success-800 text-center mt-16-16">
          {subsidyValueFormatted}
        </p>
        <p className="hc-typography--paragraph-sm font-bold mt-8-8">
          Per month
        </p>

        <Link
          id="subsidy-calculator-redirect"
          href={`https://www.healthcare.com/healthcare-insurance/survey/?${redirectParams.toString()}`}
          target="_top"
          className="hc-btn--primary flex justify-center items-center gap-8-8 px-48-48 mt-24-24 animate-btn-pulse shadow-lg w-fit mx-auto"
        >
          View Plans
          <ArrowForward className="size-24-24" />
        </Link>
      </div>

      <div className="bg-gray-0 border border-gray-50 rounded-xl py-32-32 px-24-24 mt-12-12 w-full animate-in fade-in slide-in-from-bottom-8-8 duration-1000 delay-300 fill-mode-both">
        <p className="hc-typography--paragraph-md font-bold mb-12-12">
          Savings breakdown
        </p>
        <div className="flex justify-between items-center py-12-12 border-b border-gray-50">
          <p className="hc-typography--paragraph-sm">Monthly Tax Credit</p>
          <p className="hc-typography--paragraph-sm font-bold">
            {subsidyValueFormatted}
          </p>
        </div>
        <div className="flex justify-between items-center py-12-12 border-b border-gray-50">
          <p className="hc-typography--paragraph-sm">Annual Tax Credit</p>
          <p className="hc-typography--paragraph-sm font-bold">
            {annualSubsidyValueFormatted}
          </p>
        </div>
        <div className="flex justify-between items-center pt-12-12">
          <p className="hc-typography--paragraph-lg font-bold">
            Total Annual Savings
          </p>
          <p className="hc-typography--paragraph-lg font-bold">
            {annualSubsidyValueFormatted}
          </p>
        </div>
      </div>

      <Button
        variant="primary-card-small"
        className="w-full tablet:w-fit px-32-48 bg-gray-50 text-gray-400 flex justify-center hover:bg-gray-100 mt-24-24 mr-auto"
        type="button"
        onClick={reset}
      >
        Start Over
      </Button>
    </div>
  );
}
